module.exports = __webpack_public_path__ + "assets/img/gwcc.2d491111.svg";